export const FB_PIXEL_ID = '3915502615368700'; // Replace with your actual Pixel ID

// Track page views
export const pageview = () => {
	window.fbq('track', 'PageView');
};

// Track custom events
export const event = (name: string, options = {}) => {
	window.fbq('track', name, options);
};
